import { accordian } from "../../utils/accordian/accordian.js";
// import header from "../components/header.js";
import talkExpert from "../components/talk-expert.js";

// setTimeout(function() {
    // header()
    accordian()
    talkExpert()
// },2000)